const axios = require("axios");

export const getToken = () => {
    if (localStorage.getItem("keptLogged") == "true") {
        return localStorage.getItem("token") || null;
    }
    return sessionStorage.getItem("token") || null;
};

export const getAnalytics = async (noOfDays) => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `webpageAnalytics/analytics?noOfDays=${noOfDays}`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};

export const getPageAnalytics = async (noOfDays) => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `webpageAnalytics/pagesAnalytics?noOfDays=${noOfDays}`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};

export const getSessionsAnalytics = async (noOfDays, limit, offset) => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `webpageAnalytics/sessions?noOfDays=${noOfDays}&limit=${limit}&offset=${offset}`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};

export const getUsersAnalytics = async (noOfDays, limit, offset) => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `webpageAnalytics/users?noOfDays=${noOfDays}&limit=${limit}&offset=${offset}`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};


export const getMapData = async (noOfDays) => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `webpageAnalytics/mapview?noOfDays=${noOfDays}`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};




export const getPageViews = async (body, limit, offset) => {
    const response = await axios({
        method: "post",
        url: process.env.REACT_APP_API_BASE_URL + `webpageAnalytics/pageViews?limit=${limit}&offset=${offset}`,
        headers: {
            Authorization: "Bearer " + getToken(),
        },
        data: body,
    });
    return response.data;
};

//  /webpageAnalytics/sessions/count, /webpageAnalytics/users/count


export const getSessionsCount = async (noOfDays) => {
    const response = await axios({
        method: "get",
        url: process.env.REACT_APP_API_BASE_URL + `webpageAnalytics/sessions/count?noOfDays=${noOfDays}`,
        headers: {
            Authorization: "Bearer " + getToken(),
        },
    });
    return response.data;
};


export const getUsersCount = async (noOfDays) => {
    const response = await axios({
        method: "get",
        url: process.env.REACT_APP_API_BASE_URL + `webpageAnalytics/users/count?noOfDays=${noOfDays}`,
        headers: {
            Authorization: "Bearer " + getToken(),
        },
    });
    return response.data;
};